import styled, { createGlobalStyle } from "styled-components";
import { DatePicker } from "sunday-component";

export const CustomDatePicker = styled(DatePicker)`
  &.react-datepicker-popper {
    z-index: 100;
    &[class*="sundayDatePicker"] {
      /* active, hover button */
      [class*="panel"] {
        [class*="active"],
        button:hover {
          color: var(--ui-form-calendar-selected-text-color);
          background-color: var(--ui-form-calendar-selected-background-color);
        }
      }
      /* active, hover header selection */
      [class*="header"] {
        [class*="selector"][class*="selected"] {
          border-color: var(--ui-form-calendar-selected-background-color);
          [class*="arrow"],
          [class*="buttonText"],
          [class*="BE"] {
            border-color: var(--ui-form-calendar-selected-background-color);
            color: var(--ui-form-calendar-selected-background-color);
          }
        }
      }
      /* selected day */
      .react-datepicker__day--selected {
        color: var(--ui-form-calendar-selected-text-color);
        background-color: var(--ui-form-calendar-selected-background-color);
      }
    }
  }
`;
export const DatePickerGlobalStyle = createGlobalStyle`
  .react-datepicker-wrapper {
    display: flex;
    .react-datepicker__input-container {
      .sunday-component-input-affix-wrapper:not(.sunday-component-input-affix-wrapper-disabled) {
        &:hover {
          border-color: var(--ui-form-input-date_picker-focused-border-color);
        }
      }
      .sunday-component-input-affix-wrapper-focused {
        box-shadow: 0px 0px 0px 2px var(--ui-form-input-date_picker-focused-border-shadow) ;
      }
      .sunday-component-input-affix-wrapper-disabled {
        .sunday-component-input-disabled {
          color: var(
            --ui-form-input-text-disabled-fields_text-color,
            #76777a
          ) !important;
          -webkit-text-fill-color: var(
            --ui-form-input-text-disabled-fields_text-color,
            #76777a
          );
          opacity: 1;
        }
      }

    }
  }

  /* Override legacy Sunday colors only within the Ice Cream token scope. */
  [class*="ci-ice-cream_token"] {
    .react-datepicker-wrapper
      .sunday-component-input-affix-wrapper:not(.sunday-component-input-affix-wrapper-disabled):not(.sunday-component-form-item-has-error *):not(.sunday-component-form-item-has-warning *) {
      &:hover {
        border-color: var(--color-stroke-ci, #435dff);
      }

      &.sunday-component-input-affix-wrapper-focused {
        border-color: var(--color-stroke-ci, #435dff);
        box-shadow: 0 0 0 2px var(--color-surface-ci-bright, #ecefff);
      }
    }

    .react-datepicker-popper[class*="sundayDatePicker"] {
      .react-datepicker {
        border-color: var(--color-stroke-default, #d9dbde);
        background-color: var(--color-surface-primary, #ffffff);
      }

      .react-datepicker__header,
      [class*="header"],
      [class*="listOfDays"],
      [class*="panel"] {
        background-color: var(--color-surface-primary, #ffffff);
      }

      .react-datepicker__day,
      [class*="buttonText"],
      [class*="dayname"],
      [class*="label"] {
        color: var(--color-text-primary, #202123);
      }

      [class*="BE"] {
        color: var(--color-text-secondary, #5f6468);
      }

      .react-datepicker__day--disabled,
      [class*="dayInOtherMonth"] {
        color: var(--color-text-disabled, #9fa6ad);
      }

      .react-datepicker__day:not(.react-datepicker__day--disabled):hover {
        color: var(--color-text-ci, #435dff);
        background-color: var(--color-surface-ci-bright, #ecefff);
      }

      .react-datepicker__day--selected:not(.react-datepicker__day--disabled),
      .react-datepicker__day--selected:not(.react-datepicker__day--disabled):hover,
      .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--disabled),
      .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--disabled):hover {
        border-color: var(--color-stroke-ci, #435dff);
        color: var(--color-text-on-primary, #ffffff);
        background-color: var(--color-surface-ci, #435dff);
      }

      [class*="header"] [class*="selector"] {
        background-color: var(--color-surface-secondary, #f6f7f8);

        [class*="arrow"] {
          border-color: var(--color-icon-primary, #202123);
        }

        &:not(:disabled):hover,
        &:not(:disabled):focus-visible,
        &[class*="selected"] {
          border: 1px solid var(--color-stroke-ci, #435dff);

          [class*="arrow"] {
            border-color: var(--color-icon-ci, #435dff);
          }

          [class*="buttonText"],
          [class*="BE"] {
            color: var(--color-text-ci, #435dff);
          }
        }
      }

      [class*="panel"] button[class*="buttonSelect"]:not(:disabled) {
        &[class*="active"],
        &:hover,
        &:focus-visible {
          color: var(--color-text-on-primary, #ffffff);
          background-color: var(--color-surface-ci, #435dff);

          [class*="label"] {
            color: var(--color-text-on-primary, #ffffff);
          }
        }
      }
    }
  }
`;

export const DisplayValueContainer = styled.div`
  position: relative;
  width: 100%;
  .sunday-component-input {
    color: transparent !important;
    caret-color: transparent;
  }
`;

export const DisplayValue = styled.span<{ $disabled: boolean }>`
  position: absolute;
  top: 50%;
  left: 13px;
  transform: translateY(-50%);
  font-size: 21px;
  color: ${(props) => (props.$disabled ? "#76777A" : "#2a2c2e")};
  white-space: nowrap;
  pointer-events: none;
  /* the input box gets z-index: 1 on hover/focus; stay above it */
  z-index: 2;
`;
